module.exports = __webpack_public_path__ + "img/logo_white.96506596.png";